import React from 'react';

const Why = () => (
  <div className="space-medium bg-split-top pt-5">
    <div className="container">
      <div className="row">
        <div className="col-lg-12 col-md-12 col-sm-12 col-12 text-center">
          {/* section heading start */}
          <div className="section-heading">
            <h2 className="section-heading-title">Work with a Leader in MDR</h2>
            <p className="section-heading-text">
                Paladion is a global leader in cybersecurity and managed detection and response services. Protect yourself from cyber threats and attacks by utilizing our wide range of cybersecurity consulting services.
            </p>
          </div>
          {/* section heading close */}
        </div>
      </div>
      <div className="row">
        <div className="col-xl-4 col-lg-4 col-md-6 col-sm-12 col-12 text-center">
          {/* counter block start */}
          <div className="counter-v1 counter-block">
            <div className="counter-block-icon">
              <i className="fas fa-shield-alt" />
            </div>
            <div className="counter-block-content">
              <h3 className="counter-block-text">Cyber security company with</h3>
              <p className="text-white counter-block-title">18 Years of Experience</p>
            </div>
          </div>
          {/* counter block close */}
        </div>
        <div className="col-xl-4 col-lg-4 col-md-6 col-sm-12 col-12 text-center">
          {/* counter block start */}
          <div className="counter-v1 counter-block">
            <div className="counter-block-icon">
              <i className="fas fa-users" />
            </div>
            <div className="counter-block-content">
              <h3 className="counter-block-text">A team of over</h3>
              <p className="text-white counter-block-title">1000 cyber warriors</p>
            </div>
          </div>
          {/* counter block close */}
        </div>
        <div className="col-xl-4 col-lg-4 col-md-6 col-sm-12 col-12 text-center">
          {/* counter block start */}
          <div className="counter-v1 counter-block">
            <div className="counter-block-icon">
              <i className="fas fa-atom" />
            </div>
            <div className="counter-block-content">
              <h3 className="counter-block-text">Served over </h3>
              <p className="text-white counter-block-title">700 Clients</p>
            </div>
          </div>
          {/* counter block close */}
        </div>
        <div className="col-xl-4 col-lg-4 col-md-6 col-sm-12 col-12 text-center">
          {/* counter block start */}
          <div className="counter-v1 counter-block">
            <div className="counter-block-icon">
              <i className="fas fa-award" />
            </div>
            <div className="counter-block-content">
              <h3 className="counter-block-text">Recognized by Gartner</h3>
              <p className="text-white counter-block-title">
                For MDR services
              </p>
            </div>
          </div>
          {/* counter block close */}
        </div>
        <div className="col-xl-4 col-lg-4 col-md-6 col-sm-12 col-12 text-center">
          {/* counter block start */}
          <div className="counter-v1 counter-block">
            <div className="counter-block-icon">
              <i className="fas fa-tasks" />
            </div>
            <div className="counter-block-content">
              <h3 className="counter-block-text">Responding to over</h3>
              <p className="text-white counter-block-title">100 incidents daily</p>
            </div>
          </div>
          {/* counter block close */}
        </div>
        <div className="col-xl-4 col-lg-4 col-md-6 col-sm-12 col-12 text-center">
          {/* counter block start */}
          <div className="counter-v1 counter-block">
            <div className="counter-block-icon">
              <i className="fas fa-server" />
            </div>
            <div className="counter-block-content">
              <h3 className="counter-block-text">Monitoring</h3>
              <p className="text-white counter-block-title">25 billion security event</p>
            </div>
          </div>
          {/* counter block close */}
        </div>
      </div>
    </div>
  </div>

);

export default Why;
